import GoogleMapsAPI from "../models/GoogleMapsAPI";
import React from "react";

export const googleMapsAPIContext = React.createContext(new GoogleMapsAPI());
